<div class="container">
  <div *ngIf="loading$ | async; else content" class="notifications-loading">
    <mat-spinner diameter="40" strokeWidth="4"></mat-spinner>
  </div>
  <ng-template #content>
    <div class="content">
      <div class="logo" *ngIf="(hasLogoSrc$ | async) && (whitelabelEnabled$ | async)">
        <img [src]="logoSrc$ | async" />
      </div>
      <ng-container *ngIf="(hasError$ | async) === false; else error">
        <mat-card appearance="outlined" *ngIf="(unsubscribed$ | async) === false; else unsubscribed">
          <mat-card-header>
            <mat-card-title>
              {{ 'NOTIFICATIONS_UNSUBSCRIBE.TITLE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p innerHTML="{{ 'NOTIFICATIONS_UNSUBSCRIBE.DESCRIPTION' | translate : { name: typeName$ | async } }}"></p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-button (click)="unsubscribe()" *ngIf="(unsubscribing$ | async) === false">
              {{ 'NOTIFICATIONS_UNSUBSCRIBE.UNSUBSCRIBE' | translate }}
            </button>
            <div class="unsubscribing" *ngIf="unsubscribing$ | async">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
          </mat-card-actions>
        </mat-card>
        <ng-template #unsubscribed>
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>
                {{ 'NOTIFICATIONS_UNSUBSCRIBE.SUCCESS_TITLE' | translate }}
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p
                innerHTML="{{
                  'NOTIFICATIONS_UNSUBSCRIBE.SUCCESS_DESCRIPTION' | translate : { name: typeName$ | async }
                }}"
              ></p>
            </mat-card-content>
          </mat-card>
        </ng-template>
      </ng-container>
      <ng-template #error>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>
              {{ 'NOTIFICATIONS_UNSUBSCRIBE.TITLE' | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            {{ error$ | async }}
          </mat-card-content>
        </mat-card>
      </ng-template>
    </div>
  </ng-template>
</div>
